module.exports = __webpack_public_path__ + "static/facebook-fefed7a3e0c4202bed983263253e1e26.png";